import React, { useEffect, useState } from 'react'
import { FavorGroupList } from './favor_group_list'
import { FavorGroupPanel } from './favor_group_panel'
import { store } from '../../../../store/favor/store'
import { Observer } from 'mobx-react-lite'

export function MyFavorGroup() {
  const [createPanelVisible, setCreatePanelVisible] = useState(false)
  const [slide, setSlide] = useState('')
  let timer: any = null

  const backToHome = () => {
    setSlide('')
    store.setStockScroll('stock-scroll')
    timer = setTimeout(() => {
      store.setFavorGroupVisible(false)
    }, 300)
  }

  const toggleManage = () => {
    if (store.manageBtn == '完成') {
      store.setManageBtn('管理')
    } else {
      store.setManageBtn('完成')
    }
  }

  const NewFavorGroup = () => {
    setSlide('slide-down')
    setCreatePanelVisible(true)
  }

  useEffect(() => {
    setSlide('slide-down')
    return () => {
      timer && clearTimeout(timer)
    }
  }, [])

  return (
    <Observer>
      {() => (
        <>
          <div className={`group-list-pop ${slide}`}>
            <p className="head">
              <a
                href="#"
                className="icon-slide"
                onClick={(e) => {
                  e.preventDefault()
                  backToHome()
                }}
              ></a>
            </p>
            <dl className="group-list-scroll">
              <dt>
                我的自选分组
                <a
                  href="#"
                  onClick={(e) => {
                    e.preventDefault()
                    toggleManage()
                  }}
                >
                  {store.manageBtn}
                </a>
              </dt>
              <FavorGroupList />
            </dl>
            <p className="foot">
              <a
                href="#"
                onClick={(e) => {
                  e.preventDefault()
                  NewFavorGroup()
                }}
              >
                <span className="icon-add"></span>新建自选股组
              </a>
            </p>
          </div>
          {createPanelVisible && <FavorGroupPanel type="create" onClose={() => setCreatePanelVisible(false)} />}
        </>
      )}
    </Observer>
  )
}
